import { rightArrowIcon } from "../../assets/icons/SvgIconList";

interface IValueChangeProps {
  from: string;
  to: string;
}

const ValueChange: React.FC<IValueChangeProps> = ({ from, to }) => (
  <span className="inline-flex items-center">
    <span>{from}</span>
    <span className="mx-1 size-4 shrink-0">{rightArrowIcon}</span>
    <span>{to}</span>
  </span>
);

export default ValueChange;
